/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/7/9
 */
import {stringify} from 'qs'
import request from 'utils/request'
import api from 'common/api/auth'
import {format} from 'utils/index'

export async function qrcode(params) {
    return request(`${api.qrcode.url}?${stringify(params)}`)
}

export async function agentConfig(params) {
    return request(`${api.agentConfig.url}?${stringify(params)}`)
}

export async function weworkWorkbenchAuth(params) {
    return request(`${api.weworkWorkbenchAuth.url}?${stringify(params)}`)
}

export async function companyPermissions() {
    return request(api.companyPermissions.url)
}

export async function init(params) {
    return request(`${api.init.url}?${stringify(params)}`)
}

export async function authSuite(params = {}) {
    return request(`${format(api.authSuite.url, {suite_id: params.suite_id})}?${stringify(params)}`)
}

export async function accessToken(params) {
    return request(`${api.accessToken.url}?${stringify(params)}`)
}

export async function deleteToken() {
    return request(`${api.deleteToken.url}`, {
        method: api.deleteToken.type,
    })
}

export async function setGuide(params = {}) {
    return request(`${api.setGuide.url}`, {
        method: api.setGuide.type,
        body: params,
    })
}
export async function getComponyList() {
    return request(`${api.getComponyList.url}`, {
        method: api.getComponyList.type,
    })
}
